// removed by extract-text-webpack-plugin
module.exports = {"container":"CommonWidget__container___lPH89"};